import {
  MetaFilterResponseTreasuryFiltersOffersFilters,
  ResponsesTreasuryIndexerRiskResponse,
  ResponsesTreasuryOfferResponse,
  ResponsesTreasuryWithdrawTitleResponse,
} from '@genial/services/dist/models';
import { Utils } from '@genial/utils';

import { metaFilterToOptions } from '../../../utils/metaFilterToOptions';
import {
  DirectTreasuryOfferEntityNormalized,
  DirectTreasurySellOfferEntityNormalized,
  DynamicCustomFiltersProps,
} from '../types';

import { filterHasOptions, normalizeCustomFilter } from '.';

export const normalizeDirectTreasuryOffers = (
  data?: ResponsesTreasuryOfferResponse[] | null
): DirectTreasuryOfferEntityNormalized[] => {
  if (!data) {
    return [];
  }

  return data.map(({ offer }) => {
    return {
      ...offer,
      productIdNormalized: String(offer.productId),
      productNameNormalized: offer.titleName || '',
      profitabilityNormalized: `${offer.rateIncome} + ${Utils.Mask.Percentage(offer.purchaseRate)}`,
      riskRatingLevelNormalized: String(offer?.productRisk?.risk || 0),
      maturityDateFormattedNormalized: Utils.Mask.DateFormat(
        (offer.maturityDate || '') as Date,
        'dd/MM/yyyy'
      ),
      settlementDateFormattedNormalized: Utils.Mask.DateFormat(
        (offer.settlementDate || '') as Date,
        'dd/MM/yyyy'
      ),
      settlementPeriodFormattedNormalized: offer.settlementPeriod || '',
      feesPaymentNormalized: offer.periodicityRate || '',
      inputAmountOrderNormalized: String(offer.minimumStepQuantity),
      inputApplicationAmountNormalized: Utils.Mask.Money(offer.minimumApplication),
      riskRatingNormalized: offer?.productRisk?.formatRisk || '',
    };
  });
};

export const normalizeDirectTreasuryFiltersFromMeta = (
  meta?: MetaFilterResponseTreasuryFiltersOffersFilters
): DynamicCustomFiltersProps => {
  if (!meta) {
    return { filters: [] };
  }

  const indexers = metaFilterToOptions(meta.filter.indexer);
  const risks = metaFilterToOptions(meta.filter.risk);

  const indexerFilter = normalizeCustomFilter('indexer', 'Indexador', indexers);

  const riskFilter = normalizeCustomFilter('riskRatingLevel', 'Risco', risks);

  const filtersWithValues = [indexerFilter, riskFilter].filter(filterHasOptions);

  return { filters: filtersWithValues };
};

export const normalizeDirectTreasuryFilters = (
  data?: ResponsesTreasuryIndexerRiskResponse | null
): DynamicCustomFiltersProps => {
  if (!data) {
    return { filters: [] };
  }

  const indexerFilter = normalizeCustomFilter(
    'indexer',
    'Indexador',
    data.indexerRiskFilter.indexer
  );

  const riskFilter = normalizeCustomFilter('riskRatingLevel', 'Risco', data.indexerRiskFilter.risk);

  const filtersWithValues = [indexerFilter, riskFilter].filter(filterHasOptions);

  return { filters: filtersWithValues };
};

export const normalizeDirectTreasurySellOffers = (
  data?: ResponsesTreasuryWithdrawTitleResponse[] | null
): DirectTreasurySellOfferEntityNormalized[] => {
  if (!data) {
    return [];
  }

  const formatQuantity = (quantity: number | null | undefined): string => {
    if (quantity === null || quantity === undefined) {
      return '--';
    }
    const quantityAsString = quantity.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return `${quantityAsString} unidades`;
  };

  return data.map(({ withdraw }) => {
    return {
      ...withdraw,
      productNameNormalized: withdraw.titleName || '',
      totalValueNormalized: Utils.Mask.Money(withdraw?.sellValue || 0),
      quantityAvailableNormalized: withdraw.availableQuantity,
      quantityAvailableFormatted: formatQuantity(withdraw?.availableQuantity),
      redemptionValueNormalized: Utils.Mask.Money(withdraw?.estimatedGrossValue || 0),
      availableInAccountNormalized: withdraw?.redemptionDate
        ? Utils.Mask.DateFormat(withdraw?.redemptionDate, 'dd/MM/yyyy')
        : '--',
    };
  });
};
